import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import './SnippetDetailPage.css';
import { motion } from 'framer-motion';
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';
import { ArrowCircleLeftIcon, XCircleIcon } from "@phosphor-icons/react";

const SnippetDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [snippet, setSnippet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // http://106.51.127.87:3030/LabManual/Apicall.php
  useEffect(() => {
    const fetchSnippetDetails = async () => {
      try{
        const response = await axios.get('https://carve.enminvithaigal.in/lab/Apicall.php', {
        //  const response = await axios.get('http://106.51.127.87:3030/LabManual/Apicall.php', {
          params: { Apicall: 'getSnippetDetails', solution_id: id },
        });

        if (response.data && response.data.length > 0) {
          setSnippet(response.data[0]);
        } else {
          setError('<Snippet not found... !>');
        }
      } catch (err) {
        console.error('Error fetching snippet details:', err);
        setError('Failed to fetch snippet details.');
      } finally {
        setLoading(false);
      }
    };

    fetchSnippetDetails();
  }, [id]);

  useEffect(() => {
    if (snippet) {
      const codeBlock = document.querySelector('pre code');
      if (codeBlock) hljs.highlightElement(codeBlock);
    }
  }, [snippet]);

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  if (loading) {
    return <motion.div className="loading shimmer">Loading snippet details...</motion.div>;
  }

  if (error) {
    return <motion.div className="shimmer">{error}
      <XCircleIcon size={48} color="#2df750" weight="light" onClick={handleGoBack} className='icon carve-spot-absolute close-snippet' />

    </motion.div>;
  }

  return (
    <motion.div
      initial={{ x: 10, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: -20, opacity: 0 }}
      transition={{ duration: 0.2 }}
      className='snippet-outer-wrapper'
    >

      <div className='snippet-chamber'>
        <div className='snippet-inner' >
          {snippet ? (
            <>
              <div className='snippet-t-d'>
                <h5>{snippet.program}</h5>
                <div className="snippet-description">
                  <h3>Aim</h3>
                  <p>{snippet.aim}</p>
                </div>
              </div>
              <div className="snippet-container">

                <div className="snippet-section code" style={{ minHeight: "300px", maxHeight: "600px", overflowY: "auto" }}>
                  <h2>Code Snippet</h2>
                  <pre>
                    <code className="language-javascript">{snippet.solution}</code>
                  </pre>
                </div>

                <div className="snippet-section" style={{ minHeight: "300px", maxHeight: "600px", overflowY: "auto" }}>
                  <h2>Output</h2>
                  <pre>
                    <code className="language-javascript">{snippet.output}</code>
                  </pre>
                </div>

              </div>
            </>
          ) : (
            <p className="error-image">Snippet not found</p>
          )}

          <ArrowCircleLeftIcon size={48} color="#2df750" weight="light" onClick={handleGoBack} className='icon carve-spot-absolute r-0 t-0' />
        </div>
      </div>
    </motion.div>
  );
};

export default SnippetDetailPage;
